module.exports = __webpack_public_path__ + "img/CRP_DM.325a9178.png";